import React from 'react'
import PropTypes from 'prop-types'
import { FeedbackVoucherBase, Row, IconWrapper, Text } from './styles'

const FeedbackVoucher = ({ text, status, dataTestId, title, icon }) => {
  return (
    <FeedbackVoucherBase status={status} data-testid={dataTestId}>
      {title && (
        <Row>
          {icon && <IconWrapper data-testid={`icon-${dataTestId}`}>{icon}</IconWrapper>}
          {title && <Text>{title}</Text>}
        </Row>
      )}

      {text.map(item => (
        <p key={item}>{item}</p>
      ))}
    </FeedbackVoucherBase>
  )
}

FeedbackVoucher.propTypes = {
  dataTestId: PropTypes.string,
  icon: PropTypes.instanceOf(Object),
  status: PropTypes.string,
  text: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
}

export default FeedbackVoucher
